/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CompetitionQueryResult model module.
 * @module model/CompetitionQueryResult
 * @version 1.0
 */
class CompetitionQueryResult {
    /**
     * Constructs a new <code>CompetitionQueryResult</code>.
     * @alias module:model/CompetitionQueryResult
     */
    constructor() { 
        
        CompetitionQueryResult.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CompetitionQueryResult</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CompetitionQueryResult} obj Optional instance to populate.
     * @return {module:model/CompetitionQueryResult} The populated <code>CompetitionQueryResult</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CompetitionQueryResult();

            if (data.hasOwnProperty('competitionId')) {
                obj['competitionId'] = ApiClient.convertToType(data['competitionId'], 'Number');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'String');
            }
            if (data.hasOwnProperty('deletedAt')) {
                obj['deletedAt'] = ApiClient.convertToType(data['deletedAt'], 'String');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('updatedAt')) {
                obj['updatedAt'] = ApiClient.convertToType(data['updatedAt'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} competitionId
 */
CompetitionQueryResult.prototype['competitionId'] = undefined;

/**
 * @member {String} createdAt
 */
CompetitionQueryResult.prototype['createdAt'] = undefined;

/**
 * @member {String} deletedAt
 */
CompetitionQueryResult.prototype['deletedAt'] = undefined;

/**
 * @member {String} name
 */
CompetitionQueryResult.prototype['name'] = undefined;

/**
 * @member {String} updatedAt
 */
CompetitionQueryResult.prototype['updatedAt'] = undefined;






export default CompetitionQueryResult;

